import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page
    
    // /**************************************************************
    // -> Pageload animation
    // **************************************************************/
    function pageAllExperiencesLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-all-experiences .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-all-experiences .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-all-experiences .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    }
    pageAllExperiencesLoadAnimation()

    /**************************************************************
    -> Destinations intro anim on scroll
    **************************************************************/
    function inViewAnimIntroAllExperiences() {
      gsap.fromTo('.intro-all-experiences-landing .intro-container h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-all-experiences-landing .intro-container',
      })

      gsap.fromTo('.intro-all-experiences-landing .intro-container p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-all-experiences-landing .intro-container',
      })

    }
    inViewAnimIntroAllExperiences();

    /**************************************************************
    -> Experiences quotes anim on scroll
    **************************************************************/
    function inViewAnimAllExperiencesFilter() {
      gsap.fromTo('.wrapper-all-experiences-landing filters-taxonomy-type-landing p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.wrapper-all-experiences-landing filters-taxonomy-type-landing',
      })
    }
    inViewAnimAllExperiencesFilter();

    /**************************************************************
    -> Destinations List anim on scroll
    **************************************************************/
    function inViewAnimListExperiences() {
      gsap.fromTo('.all-experiences-list .wrap-experiences-list .experience-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.all-experiences-list .wrap-experiences-list',
      })

    }
    inViewAnimListExperiences();

    // About Quote slider
    // eslint-disable-next-line no-unused-vars
    let ExperiencesQuoteSwiper = new Swiper ('.swiper-container-destinations-clients-say', {
      loop: true,
      slidesPerView: 1,
      roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-clients-say-button-next',
        prevEl: '.swiper-clients-say-button-prev',
      },
    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/all-experiences.js